import React, { useState } from "react";
import NavBar from "../Components/NavBar";
import InputDiet from "../Components/Form/InputDiet";
import { useFieldArray, useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { updateDiet } from "../Features/DietSlice";
import Loader from "../Components/Loader";

export default function Diet() {
  const diet = useSelector((state) => state.diet);
  const [isLording, setIsLording] = useState(false);
  const {dietId, dietList} = diet;
  const dispatch = useDispatch();
  const { register, control, handleSubmit, getValues } = useForm({
    defaultValues: {
      questions: dietList
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "questions",
  });

  const add = (e) => {
    e.preventDefault();
    append({ question: "" });
  };

  const removeHandle = (e, index) => {
    setIsLording(true)
    e.preventDefault();
    remove(index);
    setIsLording(false)
  };

  const saveDiet = (value) => {
    // console.log(value)
    setIsLording(true);
    dispatch(updateDiet({dietId : dietId, dietList : value}));
    setIsLording(false);
  };

  return (
    <>
    <Loader isLording={isLording} />
      <NavBar />
      <h2 className="text-center text-3xl mt-10">Diet</h2>
      <form className="sm:max-w-2xl max-w-sm mx-auto mb-20" onSubmit={handleSubmit(saveDiet)}>
        {/* <InputDiet label="Question 1" /> */}
        {fields.map((field, index) => (
          <div class="flex mt-10 gap-3 items-center col-span-4">
            <InputDiet
              label={field.question}
              getValue={getValues}
              value={`questions.${index}.question`}
              {...register(`questions.${index}.question`)}
            />
            <button
              className="bg-red-500 text-white text-lg p-2 rounded-md hover:opacity-70"
              onClick={(e) => removeHandle(e, index)}
            >
              Delete
            </button>
          </div>
        ))}
        <div className="flex justify-between">
        <button
          onClick={add}
          className="w-1/4 p-2 mt-8 mr-auto ml-auto rounded-md bg-blue-600 text-white text-lg capitalize hover:opacity-70"
        >
          add
        </button>

        <button
          type="submit"
          className="w-1/4 p-2 mt-8 mr-auto ml-auto rounded-md bg-green-600 text-white text-lg capitalize hover:opacity-70"
        >
          Save
        </button>
</div>
      </form>
    </>
  );
}
